module.exports = __webpack_public_path__ + "static/img/hopbao.2c30803.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hopbao.gif
// module id = xrmb
// module chunks = 1